import { useEffect } from 'react'
import { useParams, Navigate, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { isSupportedLang, DEFAULT_LANG } from '../../i18n'

export function LangParamSync() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (lang && isSupportedLang(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang)
    }
  }, [lang, i18n])

  if (!lang || !isSupportedLang(lang)) {
    const stored = localStorage.getItem('i18nextLng')
    const fallback = (stored && isSupportedLang(stored)) ? stored : DEFAULT_LANG
    return <Navigate to={`/${fallback}/`} replace />
  }

  return <Outlet />
}
